import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { Typeahead } from './Typeahead';
import { fetchBridgedResource } from '../../apis';
import { Map } from 'immutable';

var searchOptions = function searchOptions(_ref) {
  var _ref$search = _ref.search,
      search = _ref$search === void 0 ? Map() : _ref$search;
  return function (field, value, callback) {
    var searchFields = Map.isMap(search) && search.has('fields') && !search.get('fields').isEmpty() ? search.get('fields').toJS() : [];
    var limit = search.get('limit') || 25;
    return fetchBridgedResource({
      datastore: search.get('datastore'),
      kappSlug: search.get('kappSlug'),
      formSlug: search.get('formSlug'),
      bridgedResourceName: search.get('bridgedResourceName'),
      values: searchFields.reduce(function (values, _ref2) {
        var name = _ref2.name,
            staticValue = _ref2.value;
        return _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, staticValue || value));
      }, {})
    }).then(function (_ref3) {
      var records = _ref3.records,
          error = _ref3.error;
      return {
        suggestions: records ? records.slice(0, limit) : [],
        error: error,
        nextPageToken: records && records.length > limit
      };
    }).then(callback);
  };
}; // Converts an option object to a single unique value. Used for comparing values
// and filtering out already selected values for multi selects.


var optionToValue = function optionToValue(_ref4) {
  var _ref4$valueProp = _ref4.valueProp,
      valueProp = _ref4$valueProp === void 0 ? 'value' : _ref4$valueProp;
  return function (option) {
    return option && option.get(valueProp) || '';
  };
}; // Converts a typed in value to an option object. Used when adding custom values
// when allowNew is true.


var valueToCustomOption = function valueToCustomOption(_ref5) {
  var _ref5$valueProp = _ref5.valueProp,
      valueProp = _ref5$valueProp === void 0 ? 'value' : _ref5$valueProp,
      allowNew = _ref5.allowNew;
  return function (value) {
    return value.length > 0 ? typeof allowNew !== 'function' || allowNew(value) ? _defineProperty({}, valueProp, value) : null : null;
  };
};

var getStatusProps = function getStatusProps(_ref7) {
  var _ref7$search = _ref7.search,
      search = _ref7$search === void 0 ? Map() : _ref7$search,
      _ref7$messages = _ref7.messages;
  _ref7$messages = _ref7$messages === void 0 ? {} : _ref7$messages;

  var _ref7$messages$short = _ref7$messages["short"],
      _short = _ref7$messages$short === void 0 ? 'Type to find an option.' : _ref7$messages$short,
      _ref7$messages$empty = _ref7$messages.empty,
      empty = _ref7$messages$empty === void 0 ? 'No matches found.' : _ref7$messages$empty,
      _ref7$messages$custom = _ref7$messages.custom,
      custom = _ref7$messages$custom === void 0 ? 'No matches found. Type to enter a custom option.' : _ref7$messages$custom,
      _ref7$messages$pendin = _ref7$messages.pending,
      pending = _ref7$messages$pendin === void 0 ? 'Searching...' : _ref7$messages$pendin,
      _ref7$messages$more = _ref7$messages.more,
      more = _ref7$messages$more === void 0 ? "Too many results, first ".concat(search.get('limit') || 25, " shown. Please refine your search.") : _ref7$messages$more,
      _ref7$messages$error = _ref7$messages.error,
      error = _ref7$messages$error === void 0 ? 'There was an error fetching data.' : _ref7$messages$error;

  return function (props) {
    return {
      info: props["short"] ? _short : props.pending ? pending : null,
      warning: props.error || props.empty || props.more ? props.error ? error : props.more ? more : props.empty ? props.custom ? custom : empty : null : null
    };
  };
};

export var BridgeSelect = function BridgeSelect(props) {
  return /*#__PURE__*/React.createElement(Typeahead, {
    components: props.components || {},
    disabled: props.disabled,
    multiple: props.multiple,
    custom: props.allowNew && valueToCustomOption(props),
    search: searchOptions(props),
    minSearchLength: typeof props.minSearchLength === 'number' ? props.minSearchLength : 1,
    getSuggestionValue: optionToValue(props),
    getStatusProps: getStatusProps(props),
    value: props.value,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    placeholder: props.placeholder
  });
};